<template>
  <div class="license-container">
    <div class="tip">
      <h3 class="tip-title" :class="changeClass">{{ tipTitle }}</h3>
      <h4 class="tip-content">{{ tipContent }}</h4>
    </div>
    <el-row type="flex" class="operation-section">
      <el-col :span="9"><section-left /></el-col>
      <el-col :span="15"><section-right v-if="data != ''" :infolist="infoList" /></el-col>
    </el-row>
    <div class="modular-section">
      <h4 class="modular-section-title">{{ $t('authorizationmanagement.initialauthorization.authorizationModule') }}</h4>
      <modular-section-list v-if="data != ''" :listdata="data" />
    </div>
  </div>
</template>

<script>
import http from '@plugin/axios'
import { $t } from '@plugin/i18n'
import SectionLeft from './components/section-left'
import SectionRight from './components/section-right'
import modularSectionList from './components/modular-section-list'

export default {
  components: {
    SectionLeft,
    SectionRight,
    modularSectionList
  },
  data() {
    return {
      tipTitle: $t('authorizationmanagement.initialauthorization.tipTitleDefault'),
      tipContent: $t('authorizationmanagement.initialauthorization.tipContentDefault'),
      isLicense: 0,
      changeClass: '',
      infoList: [],
      data: ''
    }
  },
  computed: {
    empowerFlag() {
      return this.$store.getters.userInfo.empowerFlag
    }
  },
  watch: {
    empowerFlag: {
      immediate: true,
      handler() {
        this.empowerFlagHandle()
      }
    }
  },
  methods: {
    async empowerFlagHandle() {
      if (this.empowerFlag) {
        this.data = await http({
          url: '/sysMenu/getLicenseContent',
          baseURL: process.env.VUE_APP_BASE_API,
          data: {}
        })
        this.changeTitle()
        this.getInfoList(this.data)
      }
    },
    changeTitle() {
      const differenceTime = this.computingTime(this.data.notAfter)
      if (differenceTime <= 0) {
        this.tipTitle = $t('authorizationmanagement.initialauthorization.tipTitleError')
        this.tipContent = $t('authorizationmanagement.initialauthorization.tipContentError')
      } else {
        const differenceDay = differenceTime / 1000 / 60 / 60 / 24
        if (differenceDay <= 30) {
          this.tipTitle = $t('authorizationmanagement.initialauthorization.tipTitleWarningPart1') + differenceDay + $t('authorizationmanagement.initialauthorization.tipTitleWarningPart2')
          this.tipContent = $t('authorizationmanagement.initialauthorization.tipContentSuccess')
          this.changeClass = 'warning'
        } else {
          this.tipTitle = $t('authorizationmanagement.initialauthorization.tipTitleSuccess') + (this.data.notAfter || '').split(' ')[0]
          this.tipContent = $t('authorizationmanagement.initialauthorization.tipContentSuccess')
          this.changeClass = 'success'
        }
      }
    },
    computingTime(date) {
      const today = new Date()
      const todayTime = new Date(today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' 00:00:00').getTime()
      const effectDateTime = new Date(date).getTime()
      return effectDateTime - todayTime
    },
    getInfoList(res) {
      this.infoList = [
        {
          leftName: 'certificateValid',
          leftValue: res.notAfter,
          rightName: 'erpBrand',
          rightValue: res.erpType
        },
        {
          leftName: 'authorizedInstitutionUpperLimit',
          leftValue: res.consumerAmount,
          rightName: 'license',
          rightValue: res.licenseNo
        }
      ]
    }
  }

}
</script>

<style lang="scss" scoped>
.tip {
  padding: 20px;
  border-bottom: 1px solid #F3F5F6;
  background-color: #fff;
  &-title {
    font-size: 20px;
    color: #333;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 0;
  }
  &-title.success {
    color: #008EE3;
  }
  &-title.warning {
    color: #F7B500;
  }
  &-content {
    color: #757575;
    font-size: 12px;
    margin-top: 13px;
    font-weight: 500;
    margin-bottom: 0;
  }
}
.operation-section {
  background-color: #fff;
}
.modular-section {
  padding: 20px;
  margin-top: 10px;
  background-color: #fff;
  &-title {
    margin: 0;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }
}
.el-col {
  float: unset !important;
}
</style>
